const initModals = () => {
	const modals = document.querySelectorAll('[data-modal]');

	modals.forEach( (trigger) => {
		trigger.addEventListener('click', function (event) {
			event.preventDefault();
			const modal = document.getElementById(trigger.dataset.modal);
			const exits = modal.querySelectorAll('.modal-exit');

			modal.classList.add('modal--visible');

			if(modal.classList.contains('modal--type-video')) {
				const video = modal.querySelector('.modal__video');
				video.play();
			}

			exits.forEach(function (exit) {
				exit.addEventListener('click', function (event) {
					event.preventDefault();

					if(modal.classList.contains('modal--type-video')) {
						const video = modal.querySelector('.modal__video');
						video.pause();
					}

					modal.classList.remove("modal--visible");
				});
			});
		});
	});
}

export default initModals;
